
export class NotificationStore {
    private _message: string | null = '';
    private _status: boolean | null = false;
    private _timer:  ReturnType<typeof setTimeout> | undefined = undefined;

    set message(value : string | null) {
        this._message = value;
    }
    get message() {
        return this._message;
    }
    set status(value: boolean | null) {
        this._status = value;
        if (this._status) {
            this._timer = setTimeout(() => {
                this._status = false;
                clearTimeout(Number(this._timer));
            }, 2500);
        } else {
            if (this._timer) {
                clearTimeout(this._timer);
            }
        }
    }
    get status() {
        return this._status;
    }
    private static instance : NotificationStore;

    private constructor() {

    }
    static getInstance() {
        if (!NotificationStore.instance) {
            NotificationStore.instance = new NotificationStore();
        }
        return NotificationStore.instance;
    }

}
